import styled from '@emotion/styled';
import type { MicrositeResponsiveImage } from '~/model';
import MicrositeResponsiveImg from '~/components/MicrositeResponsiveImg';
import { LoadPriority } from '~/hooks/useLoadPriority';

const Section = styled.section`
	padding: 3rem 1.5rem 4rem;
`;

const Title = styled.h2`
	font-size: 2.5rem;
	text-transform: uppercase;
	letter-spacing: 0.2em;
	margin-bottom: 2rem;
`;

const Grid = styled.div`
	display: grid;
	gap: 1.5rem;
`;

export default function FloorplanBlockDelta({ floors }: { floors: MicrositeResponsiveImage[] }) {
	if (floors.length === 0) return null;

	return (
		<Section id="floor_plans">
			<Title>Floor Plans</Title>
			<Grid>
				{floors.map((floor, index) => (
					<div key={index}>
						<MicrositeResponsiveImg image={floor} priority={LoadPriority.FIRST_PAINT} />
					</div>
				))}
			</Grid>
		</Section>
	);
}
